<div class="container-fluid main-widget">
    <div class="card title-line upgrade-card overflow-hidden">
        <div class="row align-items-end">
            <div class="col-sm-8 col-11">
                <div class="card-header">
                    <h2>¡Bienvenido al sistema de <span class="txt-primary">Safe & confindence! </span></h2>
                    <p class="mt-2 f-light">La mejor transportadora ejecutiva de México. <br />
                        Por favor, bríndenos la siguiente información para la cotización y reservación de tu servicio.
                    </p>
                </div>
            </div>
        </div>

        <img class="img-fluid pattern-image" src="assets/images/dashboard/bg-1.png" alt="vector pattern">
    </div>

    <div class="row">
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="services-tab-1" role="tabpanel" aria-labelledby="services-tab-1"
                [ngClass]="{'show active': tab === 'services-tab-1'}">
                <h2 class="mb-0">Tipo de servicio</h2>
                <div class="row">
                    <div class="col-12 order-md-ii">
                        <div class="row tread-cards">
                            @for ( item of tradCards; track item) {
                            <div class="col-lg-6 col-12">
                                <div class="card widget-1" (click)="changeTypeService(item)"
                                    [ngClass]="(service.typeService == item.value) ? 'active':''">
                                    <div class="card-body common-box tabOption">
                                        <div class="widget-icon {{ item.bgColor }} widget-round">
                                            <app-common-svg-icons [icons]="item.icon"></app-common-svg-icons>
                                        </div>
                                        <div class="w-100">
                                            <h3 class="f-w-600" style="white-space: normal !important; overflow: visible; word-break: normal !important; overflow-wrap: normal !important;">{{ item.title }}</h3>
                                            <p class="f-w-500 f-light f-12" style="white-space: normal !important; overflow: visible;">{{ item.subTitle }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="service.typeService != 0">

                    <div class="col-12">
                        <div class="card title-line mb-5">
                            <div class="card-header">
                                <h2>Servicio <span class="text-info h5">{{(service.typeService == 1) ? '(A
                                        disposición)':'(Traslado)'}}</span></h2>
                            </div>
                            <div class="card-body">
                                <div class="clipboaard-container">
                                    <div class="row">
                                        <div class="col-lg-6 col-12">
                                            <div class="mb-3" *ngIf="service.typeService == 1">
                                                <label class="form-label">Ubicación</label>
                                                <select class="form-select" required="true"
                                                    [(ngModel)]="service.location" (change)="loadDestination(-1)">
                                                    <option *ngFor="let item of listLocation" [value]="item.value">
                                                        {{ item.value }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="mb-3" *ngIf="service.typeService == 2">
                                                <label class="form-label" for="cl-origin">Origen</label>
                                                <select id="cl-origin" class="form-select" required="true"
                                                    [disabled]="listCityOrigin.length == 0" [(ngModel)]="service.origin"
                                                    (change)="loadDestination(service.origin)">
                                                    <option *ngFor="let item of listCityOrigin" [value]="item.id">
                                                        {{ item.value }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="mb-3"
                                                *ngIf="service.typeService == 2 || (service.location && service.location == 'Carretera')">
                                                <label class="form-label" for="cl-destiny">Destino</label>
                                                <select id="cl-destiny" class="form-select" required="true"
                                                    [disabled]="listCityDestination.length == 0"
                                                    [(ngModel)]="service.destination">
                                                    <option *ngFor="let item of listCityDestination" [value]="item.id">
                                                        {{ item.value }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div class="card-wrapper border rounded-3 h-100 checkbox-checked">
                                                <h6 class="sub-title">Marca los complementos que necesitas </h6>
                                                <!--@for (data of borderedCheckBox; track data) {
                                                    <div class="form-check checkbox checkbox-{{data.color}} mb-0">
                                                        <input class="form-check-input" id="{{data.id}}" type="checkbox">
                                                        <label class="form-check-label" for="{{data.id}}">{{data.title}}</label>
                                                    </div>
                                                }-->
                                                <div
                                                    class="form-check checkbox checkbox-primary ps-0 main-icon-checkbox">
                                                    <ul class="checkbox-wrapper">
                                                        <li *ngFor="let data of iconCheckBox">
                                                            <input class="form-check-input checkbox-shadow"
                                                                id="{{data.id}}" type="checkbox"
                                                                [(ngModel)]="data.checked" />
                                                            <label class="form-check-label" for="{{data.id}}">
                                                                <i class="fa fa-{{data.icon}}"></i>
                                                                <span>{{data.title}}</span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-3 text-end mb-5">
                                        <button class="btn btn-secondary btn-clipboard-cut" type="button"
                                            (click)="validateStep1()">
                                            <i class="fa fa-arrow-right"></i> Continuar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- TAB 2 Vehículos (categorías) -->
            <div class="tab-pane fade show" id="services-tab-2" role="tabpanel" aria-labelledby="services-tab-2"
                [ngClass]="{'show active': tab === 'services-tab-2'}">
                <h2 class="mb-0">Reserva tu servicio</h2>
                <div class="row">
                    <div class="col-12 order-md-ii" *ngFor="let data of listService; let i = index">

                        <div class="card">
                            <div class="blog-box blog-list row align-items-start">
                                <div class="ribbon ribbon-danger titleCard">{{data.category}}</div>
                                <div class="col-12 col-sm-3 align-self-center">
                                    <img class="img-fluid sm-100-w img-quotation"
                                        [src]="(data.img) ? data.img : '../../../assets/img/login/1.jpg'" alt="">
                                </div>
                                <div class="col-sm-2 px-1">
                                    <div class="card-header card-no-border report-option py-1">
                                        <div class="header-top row text-center">
                                            <div class="col-12">
                                                <img class="img-fluid" src="../../../assets/img/service/seguridad.png"
                                                    alt="">
                                            </div>
                                            <div class="col-12">
                                                <h2>Seguridad</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0 px-0">
                                        <ul class="referral-list">
                                            <li class="mt-0" *ngFor="let item of data.security.split(',')">
                                                <div class="activity-dot-primary"></div>
                                                <a class="f-light f-w-500">{{item}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-2 px-1">
                                    <div class="card-header card-no-border report-option py-1">
                                        <div class="header-top row text-center">
                                            <div class="col-12">
                                                <img class="img-fluid" src="../../../assets/img/service/comodidad.png"
                                                    alt="">
                                            </div>
                                            <div class="col-12">
                                                <h2>Comodidad</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0 px-0">
                                        <ul class="referral-list">
                                            <li class="mt-0" *ngFor="let item of data.comfort.split(',')">
                                                <div class="activity-dot-primary"></div>
                                                <a class="f-light f-w-500">{{item}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-2 px-1">
                                    <div class="card-header card-no-border report-option py-1">
                                        <div class="header-top row text-center">
                                            <div class="col-12">
                                                <img class="img-fluid" src="../../../assets/img/service/capacidad.png"
                                                    alt="">
                                            </div>
                                            <div class="col-12">
                                                <h2>Capacidad</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body pt-0 px-0">
                                        <ul class="referral-list">
                                            <li class="mt-0" *ngFor="let item of data.capacities">
                                                <div class="activity-dot-primary"></div>
                                                <a class="f-light f-w-500">{{item.quantity}} {{item.description}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3 px-1 text-center align-self-center">
                                    <div class="blog-details">
                                        <div class="blog-date"><span>{{data.total | currency}}</span> mxn</div>
                                        <div class="blog-bottom-content">
                                            <div class="mt-0">
                                                <ng-container *ngFor="let item of iconCheckBox">
                                                    <p class="mt-0" *ngIf="item.checked">
                                                        {{ item.title }}
                                                    </p>
                                                </ng-container>
                                            </div>
                                            <div class="pricingtable-signup mt-2"><a class="btn btn-dark btn-lg"
                                                    (click)="aceptService(data)">Reserva</a></div>
                                        </div>
                                    </div>
                                </div>
                                <!--                                <div class="col-sm-7">-->
                                <!--                                    <div class="blog-details">-->
                                <!--                                        <div class="blog-date"><span>{{data.total | currency}}</span> mxn</div>-->
                                <!--                                        <h6>{{data.title}}</h6>-->
                                <!--                                        <div class="blog-bottom-content">-->
                                <!--                                            <ul class="blog-social">-->
                                <!--                                                <li>Capacidad: <span>3 pasajeros</span></li>-->
                                <!--                                                <li>3 maletas pequeñas</li>-->
                                <!--                                            </ul>-->
                                <!--                                            <hr>-->
                                <!--                                            <p class="mt-0">-->
                                <!--                                                <span [ngClass]="(item.checked) ? 'add':''"  *ngFor="let item of iconCheckBox">{{item.title}}</span>-->
                                <!--                                            </p>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                            </div>
                        </div>

                    </div>
                </div>


                <div class="mt-3 text-end mb-5">
                    <button class="btn btn-primary btn-clipboard-cut" type="button"
                        (click)="changeTab('services-tab-1')">
                        <i class="fa fa-arrow-left"></i> Regresar
                    </button>
                </div>

            </div>
            <!-- TAB 3 Reservar info cliente -->
            <div class="tab-pane fade show" id="services-tab-3" role="tabpanel" aria-labelledby="services-tab-3"
                [ngClass]="{'show active': tab === 'services-tab-3'}">
                <div class="row">
                    <form class="card" [formGroup]="serviceForm" (ngSubmit)="aceptFormService()">
                        <div class="card-header">
                            <h2 class="card-title mb-0">Información para el servicio</h2>
                        </div>
                        <div class="card-body">
                            <div class="row g-3">
                                <div class="col-xs-12 col-6">
                                    <label class="form-label">Fecha Inicio *</label>
                                    <input class="form-control" type="date" formControlName="dateInit" [min]="today"
                                        [ngClass]="{'is-invalid': serviceForm.get('dateInit')?.invalid && serviceForm.get('dateInit')?.touched}">
                                </div>
                                <div class="col-xs-12 col-6">
                                    <label class="form-label">Fecha Término *</label>
                                    <input class="form-control" type="date" formControlName="dateEnd" [min]="today"
                                        [ngClass]="{'is-invalid': serviceForm.get('dateEnd')?.invalid && serviceForm.get('dateEnd')?.touched}">
                                </div>
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h1 class="txt-primary">Datos del usuario del servicio</h1>
                                            <p>Editar en caso de ser necesario.</p>
                                        </div>
                                        <div class="card-body">
                                            <div class="row card-wrapper border rounded-3">
                                                <div class="col-md-4 col-12">
                                                    <label class="form-label">Nombre completo *</label>
                                                    <input class="form-control" type="text" formControlName="name"
                                                        [ngClass]="{'is-invalid': serviceForm.get('name')?.invalid && serviceForm.get('name')?.touched}">
                                                </div>
                                                <div class="col-md-4 col-12">
                                                    <label class="form-label">Correo electrónico *</label>
                                                    <input class="form-control" type="email" formControlName="mail"
                                                        [ngClass]="{'is-invalid': serviceForm.get('mail')?.invalid && serviceForm.get('mail')?.touched}">
                                                </div>
                                                <div class="col-md-4 col-12">
                                                    <label class="form-label">Teléfono de contacto *</label>
                                                    <input class="form-control" type="text" formControlName="phone"
                                                        [ngClass]="{'is-invalid': serviceForm.get('phone')?.invalid && serviceForm.get('phone')?.touched}">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!-- Dirección de Origen -->
                                <div class="col-md-6 col-12" formGroupName="origin">
                                    <div class="card card-absolute border rounded-3">
                                        <div class="card-header bg-primary">
                                            <h5 class="txt-light">Dirección de Origen</h5>
                                        </div>
                                        <div class="card-body">
                                            <!-- Picker de ubicaciones (opcional) -->
                                            <app-location-picker [group]="originGroup" [clientId]="clientId"
                                                                 [cityList]="listCity" label="Origen">
                                            </app-location-picker>

                                            <hr>

                                            <div class="row g-3">
                                                <div class="col-lg-8 col-12">
                                                    <label class="form-label">Calle *</label>
                                                    <input class="form-control" type="text" formControlName="street"
                                                        [ngClass]="{'is-invalid': serviceForm.get('origin.street')?.invalid && serviceForm.get('origin.street')?.touched}">
                                                </div>
                                                <div class="col-lg-2 col-6">
                                                    <label class="form-label">Núm. Ext *</label>
                                                    <input class="form-control" type="number"
                                                        formControlName="numberExt"
                                                        [ngClass]="{'is-invalid': serviceForm.get('origin.numberExt')?.invalid && serviceForm.get('origin.numberExt')?.touched}">
                                                </div>
                                                <div class="col-lg-2 col-6">
                                                    <label class="form-label">Núm. Int</label>
                                                    <input class="form-control" type="number"
                                                        formControlName="numberInt">
                                                </div>
                                                <div class="col-lg-4 col-12">
                                                    <label class="form-label">Código Postal *</label>
                                                    <input class="form-control" type="number" formControlName="cp"
                                                        maxlength="5"
                                                        [ngClass]="{'is-invalid': serviceForm.get('origin.cp')?.invalid && serviceForm.get('origin.cp')?.touched}">
                                                </div>
                                                <div class="col-lg-5 col-12">
                                                    <label class="form-label">Colonia/Localidad *</label>
                                                    <input class="form-control" type="text" formControlName="locality"
                                                        [ngClass]="{'is-invalid': serviceForm.get('origin.locality')?.invalid && serviceForm.get('origin.locality')?.touched}">
                                                </div>
                                                <div class="col-lg-7 col-12">
                                                    <label class="form-label">Ciudad/Municipio</label>
                                                    <select class="form-control" formControlName="city"
                                                        [disabled]="true">
                                                        <option value="">--Seleccione--</option>
                                                        <option *ngFor="let item of listCity" [value]="item.id">
                                                            {{ item.value }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Dirección de Destino -->
                                <div class="col-md-6 col-12" formGroupName="destination">
                                    <div class="card card-absolute border rounded-3">
                                        <div class="card-header bg-primary">
                                            <h5 class="txt-light">Dirección de Destino</h5>
                                        </div>
                                        <div class="card-body">
                                            <!-- Picker de ubicaciones (opcional) -->
                                            <app-location-picker [group]="destinationGroup" [clientId]="clientId"
                                                                 [cityList]="listCity" label="Destino">
                                            </app-location-picker>

                                            <hr>

                                            <div class="row g-3">
                                                <div class="col-lg-8 col-12">
                                                    <label class="form-label">Calle *</label>
                                                    <input class="form-control" type="text" formControlName="street"
                                                        [ngClass]="{'is-invalid': serviceForm.get('destination.street')?.invalid && serviceForm.get('destination.street')?.touched}">
                                                </div>
                                                <div class="col-lg-2 col-6">
                                                    <label class="form-label">Núm. Ext *</label>
                                                    <input class="form-control" type="number"
                                                        formControlName="numberExt"
                                                        [ngClass]="{'is-invalid': serviceForm.get('destination.numberExt')?.invalid && serviceForm.get('destination.numberExt')?.touched}">
                                                </div>
                                                <div class="col-lg-2 col-6">
                                                    <label class="form-label">Núm. Int</label>
                                                    <input class="form-control" type="number"
                                                        formControlName="numberInt">
                                                </div>
                                                <div class="col-lg-4 col-12">
                                                    <label class="form-label">Código Postal *</label>
                                                    <input class="form-control" type="number" formControlName="cp"
                                                        maxlength="5"
                                                        [ngClass]="{'is-invalid': serviceForm.get('destination.cp')?.invalid && serviceForm.get('destination.cp')?.touched}">
                                                </div>
                                                <div class="col-lg-5 col-12">
                                                    <label class="form-label">Colonia/Localidad *</label>
                                                    <input class="form-control" type="text" formControlName="locality"
                                                        [ngClass]="{'is-invalid': serviceForm.get('destination.locality')?.invalid && serviceForm.get('destination.locality')?.touched}">
                                                </div>
                                                <div class="col-lg-7 col-12">
                                                    <label class="form-label">Ciudad/Municipio</label>
                                                    <select class="form-control" formControlName="city"
                                                        [disabled]="true">
                                                        <option value="">--Seleccione--</option>
                                                        <option *ngFor="let item of listCity" [value]="item.id">
                                                            {{ item.value }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-8 col-12">
                                    <div class="card card-absolute border rounded-3">
                                        <div class="card-body">
                                            <div class="row g-3">
                                                <div class="col-lg-4 col-12">

                                                    <label class="form-label">Número de Pasajeros *</label>
                                                    <div class="input-group">
                                                        <input class="form-control" type="number" placeholder="Ej. 4"
                                                            formControlName="passengers"
                                                            [ngClass]="{'is-invalid': serviceForm.get('passengers')?.invalid && serviceForm.get('passengers')?.touched}"
                                                            readonly>
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            (click)="changeCapacityPassenger(2)"><i
                                                                class="fa fa-minus"></i></button>
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            (click)="changeCapacityPassenger(1)"><i
                                                                class="fa fa-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-12">
                                                    <label class="form-label">Horario de Pick up *</label>
                                                    <input class="form-control" type="time" placeholder=""
                                                        formControlName="pickUp"
                                                        [ngClass]="{'is-invalid': serviceForm.get('pickUp')?.invalid && serviceForm.get('pickUp')?.touched}">
                                                </div>
                                                <div class="col-lg-4 col-12">
                                                    <label class="form-label">Horario de Regreso *</label>
                                                    <input class="form-control" type="time"
                                                        formControlName="returnTime"
                                                           [ngClass]="{'is-invalid': serviceForm.get('returnTime')?.invalid && serviceForm.get('returnTime')?.touched}">
                                                </div>
                                                <div class="col-lg-6 col-12">
                                                    <label class="form-label">Línea aerea</label>
                                                    <input class="form-control" type="text" placeholder=""
                                                        formControlName="airline">
                                                </div>
                                                <div class="col-lg-6 col-12">
                                                    <label class="form-label">Número de vuelo</label>
                                                    <input class="form-control" type="text" placeholder=""
                                                        formControlName="flight">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-12">
                                    <div class="card card-absolute border rounded-3">
                                        <div class="card-body">
                                            <div class="row g-3">
                                                <div class="col-12">
                                                    <label class="form-label">Método de pago *</label>
                                                    <select class="form-control btn-square" formControlName="methodPay"
                                                        [ngClass]="{'is-invalid': serviceForm.get('methodPay')?.invalid && serviceForm.get('methodPay')?.touched}">
                                                        <option value="">--Seleccione--</option>
                                                        <option *ngFor="let item of listMethodPay" [value]="item.id">
                                                            {{ item.value }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-12">
                                                    <label class="form-label">¿Requiere Factura?</label>
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" role="switch"
                                                            formControlName="invoice"
                                                            (change)="onBooleanChange($event)" />
                                                    </div>
                                                </div>
                                                <!-- Sin factura -->
                                                <div class="col-12" *ngIf="!serviceForm.get('invoice')?.value">
                                                    <div class="alert alert-info py-2 mb-0">
                                                        <i class="fa fa-info-circle me-1"></i>
                                                        <small>La empresa le proporcionará los datos bancarios.</small>
                                                    </div>
                                                </div>
                                                <!-- Con factura -->
                                                <div class="col-12" *ngIf="serviceForm.get('invoice')?.value">
                                                    <div class="alert alert-success py-2 mb-0">
                                                        <p class="mb-1 fw-semibold"><i
                                                                class="fa fa-university me-1"></i> Datos bancarios para
                                                            transferencia:</p>
                                                        <small>
                                                            <strong>Banco:</strong> Banorte<br>
                                                            <strong>Cuenta:</strong> 0671 636 791<br>
                                                            <strong>CLABE:</strong> 072 180 0067 1636 7918<br>
                                                            <strong>RFC:</strong> SIA080313251<br>
                                                            <strong>A nombre de:</strong> Soluciones Integrales de Alto
                                                            Nivel K y A S de RL de CV
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div>
                                        <label class="form-label">Itinerario</label>
                                        <textarea class="form-control" rows="4"
                                            placeholder="Ingrese el itinerario si lo requiere"
                                            formControlName="itinerary"></textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div>
                                        <label class="form-label">Recomendación adicional</label>
                                        <textarea class="form-control" rows="4"
                                            placeholder="Si tiene alguna recomendación la puede ingresar aquí. Es opcional"
                                            formControlName="recommendation"></textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="mt-3 text-end mb-5">
                                        <button class="btn btn-primary btn-clipboard-cut me-4" type="button"
                                            (click)="changeTab('services-tab-2')">
                                            <i class="fa fa-arrow-left"></i> Regresar
                                        </button>
                                        <button type="submit" class="btn btn-secondary btn-clipboard-cut"><i
                                                class="fa fa-arrow-right"></i> Finalizar </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
